var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 175,
    viewBox: "0 0 174 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_371_5544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.157 108.114H41.8406C39.8241 108.114 38.1892 106.479 38.1892 104.462V46.2838C38.1892 44.2673 39.8241 42.6324 41.8406 42.6324H104.157C106.174 42.6324 107.809 44.2673 107.809 46.2838V104.462C107.809 106.479 106.174 108.114 104.157 108.114Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3452 105.618V47.4398C39.3452 45.4234 40.9801 43.7885 42.9966 43.7885H105.313C106.026 43.7885 106.688 43.9955 107.249 44.348C106.604 43.3187 105.462 42.6324 104.157 42.6324H41.8406C39.8241 42.6324 38.1892 44.2673 38.1892 46.2838V104.462C38.1892 105.767 38.8754 106.909 39.9048 107.555C39.5522 106.993 39.3452 106.331 39.3452 105.619V105.618Z",
    fill: "url(#paint0_linear_371_5544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4898 54.9247H49.5083V57.6021H96.4898V54.9247ZM96.4898 65.148H49.5083V67.8254H96.4898V65.148ZM96.4898 75.3736H49.5083V78.051H96.4898V75.3736ZM96.4898 85.5969H49.5083V88.2747H96.4898V85.5969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1071 76.9549L66.9128 88.7611H55.1071V76.9549Z",
    fill: "#C9C9CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.068 92.192L112.977 128.227C112.723 130.029 111.181 131.368 109.362 131.368H36.6357C34.8164 131.368 33.2747 130.029 33.0202 128.227L26.1409 79.5348C25.8306 77.3366 27.5364 75.3726 29.7564 75.3726H52.2157C54.035 75.3726 55.5768 76.7115 55.8313 78.5126L56.7328 84.8893C56.9873 86.6908 58.5291 88.0297 60.3483 88.0297H114.453C116.672 88.0297 118.378 89.9938 118.068 92.192H118.068Z",
    fill: "url(#paint1_linear_371_5544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.031 115.295H45.9667C45.6704 115.294 45.3842 115.186 45.1619 114.99C44.9396 114.794 44.7964 114.524 44.759 114.23L44.0826 108.875C44.0611 108.703 44.0763 108.529 44.1271 108.364C44.178 108.199 44.2634 108.047 44.3776 107.917C44.4918 107.788 44.6322 107.684 44.7896 107.613C44.9469 107.542 45.1176 107.505 45.2903 107.505H100.708C100.881 107.505 101.051 107.542 101.209 107.613C101.366 107.684 101.506 107.788 101.621 107.917C101.735 108.047 101.82 108.199 101.871 108.364C101.922 108.529 101.937 108.703 101.916 108.875L101.239 114.23C101.202 114.524 101.059 114.794 100.836 114.99C100.614 115.186 100.328 115.294 100.031 115.295Z",
    fill: "white",
    fillOpacity: 0.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M119.683 152.91L160.188 173.607L163.97 162.639L124.228 149.419L119.683 152.91Z",
    fill: "url(#paint2_linear_371_5544)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.577 118.887L132.544 119.988L129.443 150.369C129.443 150.369 129.171 150.673 128.512 150.555C127.853 150.437 127.162 150.07 127.162 150.07L125.085 125.918C125.085 125.918 123.883 134.459 123.967 136.861C124.03 138.671 124.649 140.88 124.98 142.769C125.266 144.394 125.865 148.279 125.865 148.279C125.865 148.279 125.157 148.603 124.78 148.676C124.403 148.749 123.919 148.347 123.919 148.347C123.919 148.347 119.022 138.841 118.959 137.036C118.896 135.231 118.577 118.887 118.577 118.887Z",
    fill: "#4B4F5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.703 148.303C123.703 148.303 123.08 149.423 122.308 150.106C121.535 150.789 120.01 151.604 119.662 151.975C119.315 152.346 119.694 152.892 119.694 152.892L123.432 152.761L126.418 150.234L126.001 147.827L123.703 148.303Z",
    fill: "#677285"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.794 149.6L130.667 152.02C130.667 152.02 129.234 153.13 127.254 153.439C125.274 153.747 123.91 153.273 123.91 153.273C123.91 153.273 123.553 152.553 124.226 152.245C124.536 152.104 125.229 151.516 125.838 150.763C126.113 150.424 127.149 149.692 127.149 149.692L129.794 149.6Z",
    fill: "#677285"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.051 103.048C136.051 103.048 137.196 104.789 137.898 104.323C138.6 103.857 142.982 99.3659 142.982 99.3659C142.982 99.3659 144.286 98.3623 144.527 98.6009C144.768 98.8395 144.092 99.3659 144.092 99.3659C144.092 99.3659 145.514 99.5056 145.959 99.5056C146.403 99.5056 147.338 100.215 146.727 100.454C146.116 100.693 143.744 100.752 143.744 100.752C143.744 100.752 140.144 107.56 138.268 108.043C136.392 108.525 133.807 105.795 133.807 105.795L136.051 103.048Z",
    fill: "#FDE7E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.76 103.173C117.76 103.173 117.01 104.71 116.329 104.341C115.649 103.972 111.833 99.9475 111.833 99.9475C111.833 99.9475 110.562 99.1691 110.251 99.3091C109.94 99.4492 110.706 99.9475 110.706 99.9475C110.706 99.9475 108.837 100.099 108.485 100.241C108.133 100.382 107.723 100.816 108.255 101.013C108.787 101.21 110.823 101.35 110.823 101.35C110.823 101.35 113.653 106.942 115.797 107.596C117.942 108.25 119.768 105.674 119.768 105.674L117.76 103.173Z",
    fill: "#FDE7E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.702 98.466V95.7183C124.702 95.7183 123.278 95.7904 122.699 94.8364C122.119 93.8825 121.963 91.1753 121.963 91.1753L122.399 89.9202L126.69 89.7388L128.945 91.6599L127.895 93.5137L127.695 93.87L128.695 98.0833L124.702 98.466Z",
    fill: "#FDE7E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_371_5544",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 89,
    width: 8,
    height: 10
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.702 98.466V95.7183C124.702 95.7183 123.278 95.7904 122.699 94.8364C122.119 93.8825 121.963 91.1753 121.963 91.1753L122.399 89.9202L126.69 89.7388L128.945 91.6599L127.895 93.5137L127.695 93.87L128.695 98.0833L124.702 98.466Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_371_5544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.494 93.1074C126.226 94.6846 124.032 95.7868 123.747 95.7868C123.461 95.7868 125.341 97.7649 125.341 97.7649L126.871 98.4663L129.043 98.0059L129.818 95.7868L128.45 93.2691C128.45 93.2691 128.762 91.5302 127.494 93.1074Z",
    fill: "url(#paint3_linear_371_5544)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116.849 104.277L118.957 107.117L120.302 105.697C120.302 105.697 119.279 111.305 118.957 113.995C118.635 116.684 118.575 119.363 118.575 119.363C118.575 119.363 121.952 120.617 124.469 120.828C126.986 121.039 132.846 120.496 132.846 120.496L132.089 104.709L134.284 106.747L136.861 103.771C136.861 103.771 132.425 96.9543 131.586 96.5571C130.747 96.16 128.415 96.5571 128.415 96.5571C128.415 96.5571 126.76 98.5154 126.089 98.5427C125.418 98.57 123.93 96.5571 123.93 96.5571C123.93 96.5571 121.552 96.1773 120.861 96.9543C120.169 97.7312 116.849 104.277 116.849 104.277Z",
    fill: "#F26522"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M121.964 91.2059C121.964 91.2059 122.469 89.9298 123.129 90.1521C123.754 90.3625 124.295 90.8632 125.072 91.0982C125.85 91.3333 125.936 90.2775 126.464 90.4557C126.992 90.634 126.643 92.1872 127.015 92.4764C127.388 92.7657 127.388 90.4557 128.181 91.0776C128.975 91.6995 127.353 93.4498 127.353 93.4498C127.353 93.4498 127.561 94.5256 127.628 94.5988C127.695 94.672 127.687 93.8161 127.687 93.8161C127.687 93.8161 128.445 93.5252 128.768 92.2131C129.091 90.9009 129.23 90.3785 128.768 89.4251C128.305 88.4717 128.173 87.725 127.015 87.2753C125.858 86.8255 124.979 87.0014 124.17 87.2753C123.361 87.5491 122.774 88.0932 122.4 88.6347C121.527 89.9199 121.964 91.2059 121.964 91.2059Z",
    fill: "#4D364F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_371_5544",
    x1: 75.14,
    y1: 77.5103,
    x2: 28.9628,
    y2: 31.3327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_371_5544",
    x1: 72.1043,
    y1: 75.3726,
    x2: 72.1043,
    y2: 131.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#DCDDE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_371_5544",
    x1: 118.277,
    y1: 158.576,
    x2: 126.065,
    y2: 178.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CFD3",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_371_5544",
    x1: 128.095,
    y1: 96.6213,
    x2: 128.095,
    y2: 93.9589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC0BE",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_371_5544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white",
    transform: "translate(26.1042 41)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTable);
export default __webpack_public_path__ + "static/media/emptyTable.399e716813b5dd9ee853cb8d4b4cb559.svg";
export { ForwardRef as ReactComponent };